import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["announcement", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import useUtilityNavDescriptions from './useUtilityNavDescriptions';
import * as views from './UtilityNav.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var UtilityNavBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  var utilityNavDescriptions = "";

  if (typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string") {
    utilityNavDescriptions = announcement.description;
  } else if (announcement !== null && announcement !== void 0 && announcement.description) {
    utilityNavDescriptions = useUtilityNavDescriptions(announcement.description);
  }

  return _jsxs(views.Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: [utilityNavDescriptions && _jsx(views.StyledTypography, {
      variant: "buttonSmall",
      children: utilityNavDescriptions
    }), announcement && _jsx(views.StyledButtonText, {
      tokens: _objectSpread({}, tokens.buttonText),
      size: "small",
      href: announcement.ctaLink,
      hover: true,
      children: announcement.ctaTitle
    })]
  }));
});
var UtilityNav = withDesignTokens(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  }
});
export default UtilityNav;